export default "__VITE_ASSET__CHuk5ebq__"